import { render, staticRenderFns } from "./UserActivityManual.vue?vue&type=template&id=23b22d8b&scoped=true&"
import script from "./UserActivityManual.vue?vue&type=script&lang=js&"
export * from "./UserActivityManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b22d8b",
  null
  
)

export default component.exports